var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAO0lEQVR42mMYBaNgFAwIWHz7+X8krDBq8ajFoxaPWjxq8ajFuCwuAeIEZEwnizHxgFk82nAYBaNgQAAA4wDzVwv38dsAAAAASUVORK5CYII=";
  export default img;